/* import __COLOCATED_TEMPLATE__ from './all-orders.hbs'; */
/* RESPONSIBLE TEAM: team-integration-apps */
import templateOnlyComponent from '@ember/component/template-only';
import type { ShippingAddress, Order } from './types';

interface Signature {
  Args: {
    shopifyOrders?: Order[] | null;
    onShippingAddressUpdate: (orderId: number, newShippingAddress: ShippingAddress) => void;
    onRefundSuccess?: () => void;
    onReplacementSuccess?: () => void;
    onGiftCardSuccess?: () => void;
    onDiscountCodeCreated?: () => void;
    expandedOrderIds: Set<number>;
    toggleOrderExpanded: (orderId: number) => void;
    shopifyCustomerId?: number;
    onNavigateToOrder?: (fromOrderId: number, toOrderId: number) => void;
    conversationId: number;
    userId: string;
  };
}

const AllOrders = templateOnlyComponent<Signature>();
export default AllOrders;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::SidebarSections::Shopify::AllOrders': typeof AllOrders;
    'inbox2/conversation-details-sidebar/sidebar-sections/shopify/all-orders': typeof AllOrders;
  }
}
